export const setSvgPositionAttributes = (
	svgMarkup: string,
	{
		x,
		y,
		width,
		height,
	}: {
		x: number
		y: number
		width: number
		height: number
	},
): string => {
	const svgTagMatch = svgMarkup.match(/^<svg\b[^>]*>/)

	if (!svgTagMatch) return svgMarkup

	const originalTag = svgTagMatch[0]

	const updatedTag = originalTag
		.replace(/\sx="[^"]*"/, '')
		.replace(/\sy="[^"]*"/, '')
		.replace(/\swidth="[^"]*"/, '')
		.replace(/\sheight="[^"]*"/, '')
		.replace(
			'<svg',
			`<svg x="${x}" y="${y}" width="${width}" height="${height}"`,
		)

	return svgMarkup.replace(originalTag, updatedTag)
}
